const type = 'RESET_NEW_CARD_FORM';

const resetNewCardForm = () => ({
  type,
});

export default resetNewCardForm;
